export const lifeStyleMethods = {
    onSignIn: 1,
    onSignOut: 2
}